import { render, staticRenderFns } from "./uploadMorePic.vue?vue&type=template&id=8deae960&scoped=true"
import script from "./uploadMorePic.vue?vue&type=script&lang=js"
export * from "./uploadMorePic.vue?vue&type=script&lang=js"
import style0 from "./uploadMorePic.vue?vue&type=style&index=0&id=8deae960&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8deae960",
  null
  
)

export default component.exports